<template>
  <div>
    <el-card>
      <el-form ref="form" :inline="true">
        <el-form-item label="爱豆名">
          <el-input
            placeholder="请输入爱豆名"
            v-model="queryForm.name"
          ></el-input>
        </el-form-item>

        <el-form-item label="时间">
          <el-date-picker
            type="datetimerange"
            v-model="times"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toQuery" icon="el-icon-search"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item class="generate">
          <el-button type="primary" @click="toAdd"
            >添加爱豆</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        :data="idolListData"
        stripe
        class="table"
        ref="userTable.multipleSelection"
        header-cell-class-name="table-header"
        border
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="id"
          label="ID"
          width="55"
          align="center"
        ></el-table-column>
    
        <el-table-column label="爱豆名" prop="name" align="center"></el-table-column>
        <el-table-column label="介绍" prop="desc" align="center"></el-table-column>
       
        <el-table-column label="缩略图" prop="avatar_url" align="center">
          <template slot-scope="scope">
            <div class="thumb_box">
              <img :src="scope.row.avatar_url" alt="" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="时间" align="center">
          <template slot-scope="scope">
            {{
                $moment(scope.row.create_time * 1000).format(
                  "YYYY-MM-DD HH:mm:ss"
                )
              }}
          </template>
        </el-table-column>
       
        <el-table-column label="操作" align="center" >
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              circle
              @click="editGoods(scope.row)"
              size="small"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              @click="removeTask(scope.row.id)"
              size="small"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>

       <!-- 分页区域 -->
     <div class="pagination">
       <span></span>
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.page"
        :page-sizes="[3, 5, 8, 10]"
        :page-size="queryForm.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        algin:="center"
      ></el-pagination>
     </div>

      <!-- 添加爱豆 -->
      <el-dialog :title="addtitle" :visible.sync="addDialog" :center=true width="40%" @close="closed" :close-on-click-modal=false>
      <el-form :model="addForm"  ref="addForm">
        <el-form-item el-form-item label="爱豆名" label-width="100px">
            <el-input
              type="text"
              v-model="addForm.name"
              placeholder="请输入爱豆名"
            />
        </el-form-item>
        <el-form-item el-form-item label="爱豆介绍" label-width="100px">
          <el-input
            type="textarea"
            :rows="4"
            v-model="addForm.desc"
            placeholder="请输入爱豆介绍"
          />
        </el-form-item>

        <el-form-item el-form-item label="缩略图" label-width="100px">
            <el-upload
              class="avatar-uploader"
              action="123"
              :show-file-list="false"
              accept="image/*"
              :before-upload="beforeThumbUpload"
            >
              <img
                v-if="thumbSrc"
                style="width: 100%"
                :src="thumbSrc"
                class="avatar"
              />
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
                style="margin-top: 85px"
              ></i>
            </el-upload>
        </el-form-item>
       
        <el-form-item label-width=40% style="margin-top: 20px;">
           <el-button type="primary" v-if="isAdd=='add'" @click="addNow" >立即添加</el-button>
           <el-button type="primary" v-else @click="editReadNow">立即修改</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    </el-card>
  </div>
</template>

<script>
var COS = require("cos-js-sdk-v5");
import {
  IdolList,
  IdolAdd,
  IdolEdit,
  IdolDel,
  getIdolCosToken,
} from "@/api/Korean/idol.js";
export default {
  data() {
    return {
      queryForm: {
        name: "",
        page: 1,
        limit: 10,
        start_time: null,
        end_time: null,
      },
      idolListData: [],
      total: 0,
      addDialog: false,
      times: null,
      addForm: {
        name: "",
        desc: "",
        avatar: "",
      },
      addtitle: "",
      isAdd: "add",
      thumbSrc: "",
    };
  },

  created() {
    this.getIdolList();
  },
  methods: {
    //   韩语APP爱豆列表
    getIdolList() {
      IdolList(this.queryForm).then((res) => {
        if (res.code !== 1) {
          this.$message.error(res.msg);
          return;
        }
        this.total = res.data.total;
        this.idolListData = res.data.data;
      });
    },

    // 删除爱豆
    async removeTask(id) {
      const result = await this.$confirm("是否要删除该爱豆?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (result !== "confirm") return this.$message.info("已经取消删除");
      IdolDel({ id: id }).then((res) => {
        if (res.code !== 1) {
          this.$message.error(res.msg);
          return;
        }
        this.$message.success("删除爱豆成功");
        this.getIdolList();
      });
    },

    // 添加弹窗
    toAdd() {
      this.isAdd = "add";
      this.addtitle = "添加爱豆";
      this.addDialog = true;
    },
    // 上传缩略图
    beforeThumbUpload(file) {
      const isSize = file.size / 1024 / 1024 < 10;
      if (!isSize) {
        this.$message.error("上传缩略图不能超过 10MB!");
        return;
      }
      let that = this;
      getIdolCosToken({ suffix: file.name }).then((res) => {
        var cos = new COS({
          getAuthorization: function (options, callback) {
            callback({
              TmpSecretId: res.data.credentials.tmpSecretId,
              TmpSecretKey: res.data.credentials.tmpSecretKey,
              XCosSecurityToken: res.data.credentials.sessionToken,
              StartTime: res.data.startTime,
              ExpiredTime: res.data.expiredTime,
              expiration: res.data.expiration,
              requestId: res.data.requestId,
            });
          },
        });
        cos.putObject(
          {
            Bucket: res.data.Bucket,
            Region: res.data.Region,
            Key: res.data.key,
            // ContentType:'multipart/form-data',
            Body: file, // 上传文件对象
            onProgress: function (progressData) {},
          },
          function (err, data) {
            if (data) {
              that.addForm.avatar = res.data.key;
              const reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = (e) => {
                that.thumbSrc = e.target["result"]; // 获取文件装换后的Base64位文件
                that.$forceUpdate();
              };
            }
          }
        );
      });
    },

    // 添加爱豆
    addNow() {
      if (this.addForm.name == "") {
        this.$message.error("请输入爱豆名");
        return;
      } else if (this.addForm.desc == "") {
        this.$message.error("请输入爱豆介绍");
        return;
      } else if (this.addForm.avatar == "") {
        this.$message.error("请上传爱豆缩略图");
        return;
      }
      IdolAdd(this.addForm).then((res) => {
        if (res.code !== 1) {
          this.$message.error(res.msg);
          return;
        }
        this.$message.success("添加爱豆成功");
        this.addDialog = false;
        this.getIdolList();
      });
    },

    // 点击编辑图标
    editGoods(item) {
      this.isAdd = "edit";
      this.addtitle = "编辑爱豆";
      this.addDialog = true;
      this.addForm = JSON.parse(JSON.stringify(item));
      this.thumbSrc = item.avatar_url;
    },

    // 点击立即修改
    editReadNow() {
      if (this.addForm.name == "") {
        this.$message.error("请输入爱豆名");
        return;
      } else if (this.addForm.desc == "") {
        this.$message.error("请输入爱豆介绍");
        return;
      } else if (this.addForm.avatar == "") {
        this.$message.error("请上传爱豆缩略图");
        return;
      }
      IdolEdit(this.addForm).then((res) => {
        if (res.code !== 1) {
          this.$message.error(res.msg);
          return;
        }
        this.$message.success("修改爱豆成功");
        this.addDialog = false;
        this.getIdolList();
      });
    },

    // 弹窗关闭事件
    closed() {
      this.addForm = {
        name: "",
        desc: "",
        avatar: "",
      };
      this.thumbSrc = "";
    },

    //  查询
    toQuery() {
      this.queryForm.page = 1;
      if (this.times) {
        this.queryForm.start_time = new Date(this.times[0]).getTime() / 1000;
        this.queryForm.end_time = new Date(this.times[1]).getTime() / 1000;
      } else if (this.times == null) {
        this.queryForm.start_time = null;
        this.queryForm.end_time = null;
      }
      this.getIdolList();
    },
    handleSizeChange(size) {
      this.queryForm.limit = size;
      this.getIdolList();
    },
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getIdolList();
    },
  },
};
</script>

<style scoped lang="less">
.generate {
  float: right;
}
.el-tag {
  cursor: pointer;
}
::v-deep .ql-editor {
  min-height: 400px;
}
.thumb_box {
  width: 100%;
  height: 100%;

  img {
    width: 200px;
    height: 120px;
  }
}

.video_box {
  width: 100%;
  height: 300px;
  margin-bottom: 10px;
  video {
    width: 100%;
    height: 100%;
  }
}
</style>
